














































































































































































































































































































































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import { AuthModule } from '@/store/Auth/AuthModule';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PaymentState from '@/components/Accounts/Shared/Payments/PaymentState.vue';
import PaymentStateModel from '@/models/Accounts/Shared/Payments/PaymentState';
import PaymentOrder from '@/models/Accounts/Shared/PaymentOrders/PaymentOrder'
import PaymentOrderState from '@/components/Accounts/Shared/PaymentOrders/PaymentOrderState.vue';
import PaymentOrderStateModel from '@/models/Accounts/Shared/PaymentOrders/PaymentOrderState';
import PaymentOrderFeeState from '@/components/Accounts/Shared/PaymentOrders/PaymentOrderFeeState.vue';
import PaymentOrderFeeStateModel from "@/models/Accounts/Shared/PaymentOrders/PaymentOrderFeeState";
import PaymentOrderCreate from '@/components/Accounts/Shared/PaymentOrders/PaymentOrderCreate.vue';
import HawkAIPaymentOrderCreate from '@/components/Accounts/Shared/PaymentOrders/HawkAIPaymentOrderCreate.vue';
import PaymentOrderPaymentsDialog from '@/components/Accounts/Shared/PaymentOrders/PaymentOrderPaymentsDialog.vue';
import PaymentOrderCancel from '@/components/Accounts/Shared/PaymentOrders/PaymentOrderCancel.vue';
import PaymentOrderReject from '@/components/Accounts/Shared/PaymentOrders/PaymentOrderReject.vue';
import PermissionType from '@/models/Settings/Roles/PermissionType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'PaymentOrders', components: {
    PaymentState,
    PaymentOrderState,
    PaymentOrderFeeState,
    PaymentOrderCreate,
    HawkAIPaymentOrderCreate,
    PaymentOrderPaymentsDialog,
    PaymentOrderCancel,
    PaymentOrderReject
} })
export default class extends SaascadaVue {

    @Prop({required: true})
    isCustomerAccount: boolean;

    @Prop({required: true})
    isInstitutionAccount: boolean;

    @Prop({required: true})
    accountId: string;

    @Prop({required: true})
    currency: string;

    PermissionUtils = PermissionUtils;
    PaymentOrderStateModel = PaymentOrderStateModel;
    PaymentOrderFeeStateModel = PaymentOrderFeeStateModel;
    PaymentStateModel = PaymentStateModel;

    paymentOrdersPage = 1;
    headers = [
        { text: this.$t('pageText.depositAccounts.fields.name'), width: "30%", sortable: false },
        { text: this.$t('pageText.depositAccounts.fields.amount'), width: "25%", sortable: false },
        { text: this.$t('pageText.depositAccounts.fields.bulk'), width: "20%", sortable: false },
        { text: this.$t('pageText.depositAccounts.fields.state'), width: "25%", sortable: false }
    ];

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.paymentOrdersPage = +page;
        }
    }

    async beforeMount() {
        if (this.isCustomerAccount) {
            await DepositAccountModule.getPaymentOrders(this.paymentOrdersPage);
        }
        // Same for both institution accounts and third party accounts
        else {
            await InstitutionAccountModule.getPaymentOrders({ id: this.accountId, pageNumber: this.paymentOrdersPage });
        }
    }

    async getPaymentOrders() {
        if (this.isCustomerAccount) {
            await DepositAccountModule.getPaymentOrders(this.paymentOrdersPage);
        }
        // Same for both institution accounts and third party accounts
        else {
            await InstitutionAccountModule.getPaymentOrders({ id: this.accountId, pageNumber: this.paymentOrdersPage });
        }
    }

    @Watch('paymentOrdersPage')
    async onPaymentOrdersPageChanged() {
        // Update route with tab and page number (if it has changed)
        if (this.paymentOrdersPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.paymentOrdersPage}` } });
        }
        // Get new payment orders
        if (this.isCustomerAccount) {
            await DepositAccountModule.getPaymentOrders(this.paymentOrdersPage);
        }
        // Same for both institution accounts and third party accounts
        else {
            await InstitutionAccountModule.getPaymentOrders({ id: this.accountId, pageNumber: this.paymentOrdersPage });
        }
    }

    @Watch('paymentOrders')
    async onPaymentOrdersChanged() {
        // When the payment orders have loaded get the payments for the first one in the list
        if (this.paymentOrders.length > 0) {
            if (this.isCustomerAccount) {
                await DepositAccountModule.getPaymentsForPaymentOrder();
            }
            // Same for both institution accounts and third party accounts
            else {
                await InstitutionAccountModule.getPaymentsForPaymentOrder(this.paymentOrders[0].id);
            }
        }
    }

    async updateCurrentPaymentOrder(paymentOrder: PaymentOrder) {
        // Update the current payment order then clear the current payments to avoid data looking mixed up in the UI
        if (this.isCustomerAccount) {
            await DepositAccountModule.updateCurrentPaymentOrder(paymentOrder);
            await DepositAccountModule.clearPaymentsForPaymentOrder();
            await DepositAccountModule.getPaymentsForPaymentOrder();
        }
        // Same for both institution accounts and third party accounts
        else {
            await InstitutionAccountModule.updateCurrentPaymentOrder(paymentOrder);
            await InstitutionAccountModule.clearPaymentsForPaymentOrder();
            await InstitutionAccountModule.getPaymentsForPaymentOrder(paymentOrder.id);
        }
    }

    get currentPaymentOrder() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.currentPaymentOrder;
        }
        // Same for both institution accounts and third party accounts
        else {
            return InstitutionAccountModule.currentPaymentOrder;
        }
    }

    get loadingPaymentOrders() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.loadingPaymentOrders;
        }
        // Same for both institution accounts and third party accounts
        else {
            return InstitutionAccountModule.loadingPaymentOrders;
        }
    }

    get loadingPaymentsForPaymentOrder() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.loadingPaymentsForPaymentOrder;
        }
        // Same for both institution accounts and third party accounts
        else {
            return InstitutionAccountModule.loadingPaymentsForPaymentOrder;
        }
    }

    get totalPaymentOrdersPages() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.totalPaymentOrdersPages;
        }
        // Same for both institution accounts and third party accounts
        else {
            return InstitutionAccountModule.totalPaymentOrdersPages;
        }
    }

    get pageSize() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.pageSize;
        }
        // Same for both institution accounts and third party accounts
        else {
            return InstitutionAccountModule.pageSize;
        }
    }

    get paymentOrders() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.paymentOrders;
        }
        // Same for both institution accounts and third party accounts
        else {
            return InstitutionAccountModule.paymentOrders;
        }
    }

    get paymentsForPaymentOrder() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.paymentsForPaymentOrder;
        }
        // Same for both institution accounts and third party accounts
        else {
            return InstitutionAccountModule.paymentsForPaymentOrder;
        }
    }

    get showPaymentMetadata() {
        if (this.paymentsForPaymentOrder[0].metadata) {
            return Object.keys(this.paymentsForPaymentOrder[0].metadata).length !== 0;
        }
        else {
            return false;
        }
    }

    get showHawkAIDemo() {
        // Only show the HawkAIDemo if this is a customer account and the feature toggle is enabled
        return this.isCustomerAccount && PermissionUtils.isFeatureToggleEnabled('HawkAIDemo');
    }

    get showCreate() {
        // Just check the permissions for create
        if (this.isCustomerAccount) {
            return PermissionUtils.hasPermission(PermissionType.DepositPaymentOrdersManage);
        }
        else if (this.isInstitutionAccount) {
            return PermissionUtils.hasPermission(PermissionType.InstitutionalPaymentOrdersManage);
        }
        else {
            return PermissionUtils.hasPermission(PermissionType.ThirdPartyPaymentOrdersManage);
        }
    }

    get showApproval() {
        // If the payment order is not pending, then it cannot be approved
        if (this.currentPaymentOrder.state !== PaymentOrderStateModel.PendingApproval) {
            return false;
        }
        // If the payment order was created by the current user, then it cannot be approved
        if (this.currentPaymentOrder.createdByIdentifier.entityId === AuthModule.me.id) {
            return false;
        }
        // If the payment order was already approved by the current user as approver 1, then it cannot be approved again
        if (this.currentPaymentOrder.approval1By) {
            if (this.currentPaymentOrder.approval1ByIdentifier.entityId === AuthModule.me.id) {
                return false;
            }
        }
        // If the payment order was already approved by the current user as approver 2, then it cannot be approved again
        if (this.currentPaymentOrder.approval2By) {
            if (this.currentPaymentOrder.approval2ByIdentifier.entityId === AuthModule.me.id) {
                return false;
            }
        }
        // If the payment order was already approved by the current user as approver 3, then it cannot be approved again
        if (this.currentPaymentOrder.approval3By) {
            if (this.currentPaymentOrder.approval3ByIdentifier.entityId === AuthModule.me.id) {
                return false;
            }
        }
        // Otherwise finally, check the actual permissions
        if (this.isCustomerAccount) {
            return PermissionUtils.hasPermission(PermissionType.DepositPaymentOrdersManage);
        }
        else if (this.isInstitutionAccount) {
            return PermissionUtils.hasPermission(PermissionType.InstitutionalPaymentOrdersManage);
        }
        else {
            return PermissionUtils.hasPermission(PermissionType.ThirdPartyPaymentOrdersManage);
        }
    }

    get showReject() {
        // If the payment order is not pending, then it cannot be rejected
        if (this.currentPaymentOrder.state !== PaymentOrderStateModel.PendingApproval) {
            return false;
        }
        // The creator of the payment order shouldn't be able to reject it (you can only cancel it)
        if (this.currentPaymentOrder.createdByIdentifier.entityId === AuthModule.me.id) {
            return false;
        }
        // Otherwise finally, check the actual permissions
        if (this.isCustomerAccount) {
            return PermissionUtils.hasPermission(PermissionType.DepositPaymentOrdersManage);
        }
        else if (this.isInstitutionAccount) {
            return PermissionUtils.hasPermission(PermissionType.InstitutionalPaymentOrdersManage);
        }
        else {
            return PermissionUtils.hasPermission(PermissionType.ThirdPartyPaymentOrdersManage);
        }
    }

    get showCancel() {
        // If the payment order is not pending, then it cannot be cancelled
        if (this.currentPaymentOrder.state !== PaymentOrderStateModel.PendingApproval) {
            return false;
        }
        // If you are not the creator of the payment order shouldn't be able to cancel it (you can only reject it)
        if (this.currentPaymentOrder.createdByIdentifier.entityId !== AuthModule.me.id) {
            return false;
        }
        // Otherwise finally, check the actual permissions
        if (this.isCustomerAccount) {
            return PermissionUtils.hasPermission(PermissionType.DepositPaymentOrdersManage);
        }
        else if (this.isInstitutionAccount) {
            return PermissionUtils.hasPermission(PermissionType.InstitutionalPaymentOrdersManage);
        }
        else {
            return PermissionUtils.hasPermission(PermissionType.ThirdPartyPaymentOrdersManage);
        }
    }

    async approve() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Approve",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to approve this payment order?', options);
        if (result) {
            if (this.isCustomerAccount) {
                await DepositAccountModule.approvePaymentOrder();
            }
            // Same for both institution accounts and third party accounts
            else {
                await InstitutionAccountModule.approvePaymentOrder();
            }
        }
    }

}
